import { FilterOption } from '../Filter/Filter';

export const TableSizeOptions: Array<
  FilterOption & { tableSizeFrom: number; tableSizeTo: number }
> = [
  { id: 1, label: 'FR', tableSizeFrom: 7, tableSizeTo: 9 },
  { id: 2, label: 'SH', tableSizeFrom: 3, tableSizeTo: 6 },
  { id: 3, label: 'HU', tableSizeFrom: 2, tableSizeTo: 2 },
];
